export default __webpack_public_path__ + "locales/sk/FilesSettings.json?hash=4395c00f35a3695aa8a8d6a69df4a2fb";